import { jsx as o, jsxs as N, Fragment as O } from "react/jsx-runtime";
import { c as T } from "./clsx-OuTLNxxd.js";
import { forwardRef as B } from "react";
import { I as n } from "./icon-BnqXyiyH.js";
import "./components/elements/icon/iconsList.js";
import { Loader as I } from "./components/elements/loader/loader.js";
const k = "_button_z1os6_29", x = "_disabled_z1os6_43", S = "_loader_z1os6_263", s = {
  button: k,
  disabled: x,
  "is-primary": "_is-primary_z1os6_51",
  "is-contrasted": "_is-contrasted_z1os6_65",
  "is-secondary": "_is-secondary_z1os6_74",
  "is-tertiary": "_is-tertiary_z1os6_97",
  "is-eco-green": "_is-eco-green_z1os6_120",
  "is-ghost": "_is-ghost_z1os6_134",
  "is-destructive": "_is-destructive_z1os6_157",
  "is-hollow": "_is-hollow_z1os6_171",
  "is-destructive-ghost": "_is-destructive-ghost_z1os6_189",
  "is-facebook": "_is-facebook_z1os6_203",
  "is-apple": "_is-apple_z1os6_217",
  "is-google": "_is-google_z1os6_231",
  "is-regular": "_is-regular_z1os6_245",
  "is-medium": "_is-medium_z1os6_248",
  "is-small": "_is-small_z1os6_251",
  "is-full-width": "_is-full-width_z1os6_254",
  "is-loading": "_is-loading_z1os6_257",
  loader: S,
  "dialog-overlay-show": "_dialog-overlay-show_z1os6_1",
  "dialog-content-show": "_dialog-content-show_z1os6_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_z1os6_1"
}, C = B(
  ({
    color: g = "primary",
    text: m,
    size: u = "regular",
    isFullWidth: h = !1,
    icon: e,
    iconPosition: i = "left",
    iconSize: a,
    onClick: z,
    children: p,
    disabled: t,
    type: f = "button",
    className: y = "",
    href: l,
    isLoading: r,
    isContrasted: b = !1,
    ...w
  }, _) => {
    const v = T(
      s.button,
      s[U[g]],
      s[j[u]],
      h && s["is-full-width"],
      t && s.disabled,
      i === "right" && s["has-icon-right"],
      b && s["is-contrasted"],
      r && s["is-loading"],
      y
    ), d = /* @__PURE__ */ N(O, { children: [
      r && /* @__PURE__ */ o(I, { className: s.loader, onDark: !0, size: "small" }),
      e && i === "left" && /* @__PURE__ */ o(n, { color: "inherit", size: a, name: e }),
      p ?? m,
      e && i === "right" && /* @__PURE__ */ o(n, { color: "inherit", size: a, name: e })
    ] }), c = {
      onClick: z,
      className: v,
      ...w
    };
    return l ? /* @__PURE__ */ o("a", { href: t ? void 0 : l, ref: _, ...c, children: d }) : /* @__PURE__ */ o(
      "button",
      {
        ref: _,
        disabled: r || t,
        type: f,
        ...c,
        children: d
      }
    );
  }
);
C.displayName = "Button";
const U = {
  primary: "is-primary",
  secondary: "is-secondary",
  tertiary: "is-tertiary",
  "eco-green": "is-eco-green",
  ghost: "is-ghost",
  "destructive-ghost": "is-destructive-ghost",
  destructive: "is-destructive",
  hollow: "is-hollow",
  facebook: "is-facebook",
  apple: "is-apple",
  google: "is-google"
}, j = {
  small: "is-small",
  medium: "is-medium",
  regular: "is-regular"
}, A = {
  left: "left",
  right: "right"
};
export {
  C as B,
  U as a,
  j as b,
  A as c
};
